"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(require("./studioJob.data"), exports);
__exportStar(require("./studioEventCreate.data"), exports);
__exportStar(require("./studioEventRemove.data"), exports);
__exportStar(require("./studioEventUpdate.data"), exports);
__exportStar(require("./studioNewsCreate.data"), exports);
__exportStar(require("./studioNewsRemove.data"), exports);
__exportStar(require("./studioNewsUpdate.data"), exports);
__exportStar(require("./studioPersonBase.data"), exports);
__exportStar(require("./studioOtherSubmit.data"), exports);
__exportStar(require("./studioPersonCreate.data"), exports);
__exportStar(require("./studioPersonRemove.data"), exports);
__exportStar(require("./studioPersonUpdate.data"), exports);
__exportStar(require("./studioPresentationCreate.data"), exports);
__exportStar(require("./studioPresentationRemove.data"), exports);
__exportStar(require("./studioPresentationUpdate.data"), exports);
